import React, { useState, useEffect } from 'react';
import './withScrollLock.css';

export interface WithScrollLockProps {
  modalIsOpen :boolean;
  setModalIsOpen: (isOpen: boolean) => void;
}

const withScrollLock = <P extends WithScrollLockProps>(
  WrappedComponent: React.ComponentType<P>,
) => {
  const WithScrollLock: React.FC<Omit<P, keyof WithScrollLockProps>> = (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    useEffect(() => {
      if (modalIsOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }, [modalIsOpen]);

    return (
      <>
        {modalIsOpen && (
          <div className="modal-overlay" />
        )}
        <WrappedComponent
          {...(props as P)}
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
        />
      </>
    );
  };
  return WithScrollLock;
};

export default withScrollLock;
